import { http } from '@/utils/index'

/**
 * 产品相关API
 */

// 查询上架产品列表（分页）
export function getOnShelfProducts(params) {
  return http.request('get', '/product/onshelf', { params })
}

// 查询热销产品
export function getHotProducts(size = 6) {
  return http.request('get', '/product/hot', { params: { size } })
}

// 根据ID查询产品详情
export function getProductById(id) {
  return http.request('get', `/product/${id}`, {})
}

// 获取所有启用的分类
export function getEnabledCategories() {
  return http.request('get', '/product/categories/enabled', {})
}
